import { NavigationProp, RouteProp, useFocusEffect, useIsFocused, useNavigation, useRoute } from '@react-navigation/native';
import { default as React, useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import Toast from 'react-native-toast-message';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { ScrollView } from 'react-native-web-hover';
import ActingBodiesDropdown from '../../../components/access/ActingBodiesDropdown';
import CustomButton from '../../../components/CustomButton';
import FormInput from '../../../components/FormInput';
import MyAppText from '../../../components/MyAppText';
import { MyCheckbox } from '../../../components/MyCheckbox';
import { SelectableItem, SelectableList } from '../../../components/SelectableList';
import { Tabs } from '../../../components/Tabs';
import { accessService } from '../../../services/central-api/access';
import { translate } from '../../../services/translate';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import Card from '../../../components/Card';
import { useAuth } from '../../../context/Auth';
import Divider from '../../../components/Divider';
import { TextInputMask } from 'react-native-masked-text';
import { WindowInformation } from '../../../services/window-information';
import ActingBodiesUnitsDropdown from '../../../components/Dropdowns/ActingBodiesUnitsDropdown';
import { AccessParamList } from '../../../typings/Params';

export const defaultPermissionsValue: UserPermissions = {
    lpr_edit_denylist: false,
    lpr_see_denylist: false,
    lpr_edit_illegal_debris: false,
    lpr_see_illegal_debris: false,
    lpr_module_access: false,
    lpr_edit_detection: false,
    lpr_watch_unit_detections: false,
    lpr_can_watch_all_events: false,
    facial_module_access: false,
    manage_missing_person: false,
    manage_wanted_person: false,
    facial_events_wanted_person: false,
    facial_events_missing_person: false,
    facial_alerts_wanted_person: false,
    facial_alerts_missing_person: false,
    facial_manage_tags: false,
    facial_can_watch_all_events: false,
    dispatch_module_access: false,
    dispatch_see_resume: false,
    dispatch_manage_occurrence_tags: false,
    dispatch_manage_report_tags: false,
    dispatch_manage_units: false,
    dispatch_manage_vehicle_relations: false,
    dispatch_manage_person_relations: false,
    dispatch_manage_objects_categories: false,
    dispatch_manage_providences: false,
    dispatch_manage_city_property: false,
    dispatch_manage_all_acting_bodies_city_property: false,
    dispatch_manage_handcuff_reasons: false,
    dispatch_manage_all_acting_bodies_handcuff_reasons: false,
    reopen_occurrence: false,
    transfer_occurrence: false,
    events_module_access: false,
    events_manage_wanted_face_occurrence: false,
    events_manage_missing_face_occurrence: false,
    events_manage_not_allowed__face_occurrence: false,
    events_manage_wanted_plate_occurrence: false,
    events_manage_wanted_plate_by_mobile_agent_occurrence: false,
    events_manage_wanted_plate_by_citizen_app_occurrence: false,
    events_manage_irregular_vehicle_occurrence: false,
    events_manage_clone_suspect_occurrence: false,
    events_manage_illegal_debris_occurrence: false,
    events_manage_area_invasion_occurrence: false,
    events_manage_mp_wanted_plate_occurrence: false,
    events_manage_mp_wanted_mobile_agent_plate_occurrence: false,
    events_manage_mp_wanted_face_occurrence: false,
    events_manage_alarm_center_occurrence: false,
    events_manage_guardian_app_occurrence: false,
    events_manage_school_app_occurrence: false,
    events_manage_sigrc_occurrence: false,
    events_manage_cortex_plate_occurrence: false,
    events_manage_manual_occurrence: false,
    events_manage_camera_depredation_occurrence: false,
    share_mosaic_with_all_acting_bodies: false,
    share_mosaic_with_same_acting_body: false,
    share_mosaic_with_same_acting_body_unit: false,
    camera_management: false,
    camera_download_video: false,
    camera_download_report: false,
    camera_management_point_of_interest: false,
    camera_manage_tags: false,
    camera_manage_download_tags: false,
    create_camera_maintenance_requests: false,
    create_emergency_camera_maintenance_requests: false,
    manage_camera_alert_groups: false,
    silence_camera_events: false,
    camera_watch_download: false,
    camera_watch_download_acting_body_units: false,
    camera_watch_download_all_acting_bodies: false,
    dashboard_module_access: false,
    dashboard_see_occurrence: false,
    dashboard_see_cameras: false,
    dashboard_see_agents: false,
    dashboard_see_agents_acting_bodies: false,
    dashboard_see_agents_acting_body_units: false,
    dashboard_manage_monitoring_plates_groups: false,
    dashboard_manage_monitoring_plates: false,
    dashboard_see_monitoring_plates: false,
    smart_search_module_access: false,
    logs_module_access: false,
    crm_module_access: false,
    get_camera_password: false,
    search_people_by_picture: false,
    search_people_cortex: false,
    search_cortex_any_time: false,
    app_agent_pause_unit: false,
    app_agent_deac_access: false,
    app_agent_manage_services: false,
    receive_occurrences: false,
    access_edit_platform_settings: false,
    access_edit_user_settings: false,
    access_remove_user_acting_body: false,
    access_remove_user_all_acting_bodies: false,
    access_edit_user_acting_body_units: false,
    access_edit_user_all_acting_bodies: false,
    access_remove_user_acting_body_unit: false,
    access_management_user_tags: false,
    access_edit_group_settings: false,
    access_edit_group_settings_acting_body_unit: false,
    access_edit_group_settings_all_acting_bodies: false,
    access_edit_permission_level_settings: false,
    access_edit_permission_level_settings_acting_body_unit: false,
    access_edit_permission_level_settings_all_acting_bodies: false,
    access_edit_turnstile: false,
    access_manage_acting_body: false,
    access_manage_allowed_ips: false,
    access_manage_installation_company: false,
    access_manage_internet_company: false,
    access_manage_ptz_priorities: false,
    access_require_two_factor_authentication: false,
    access_see_abuse_reports: false,
    access_manage_abuse_reports: false,
    access_manage_work_schedules: false,
    access_manage_all_acting_bodies_work_schedules: false,
    access_manage_all_acting_bodies_skills: false,
    access_manage_skills: false,
    access_manage_holidays: false,
    manage_support_tickets: false,
    create_support_ticket: false,
    dispatch_generate_report: false,
    dispatch_download_report: false,
    dispatch_manage_team_names: false,
    camera_video_analysis: false,
    camera_watch_video_analysis: false,
    camera_can_watch_all_cameras: false,
    camera_offline_historic_report: false,
    dispatch_manage_acting_body_units: false,
    dispatch_manage_all_acting_bodies_units: false,
    dispatch_manage_occurrences: false,
    dispatch_manage_all_acting_bodies_occurrences: false,
    dispatch_manage_all_acting_bodies_occurrence_types: false,
    dispatch_manage_all_acting_bodies_occurrence_tags: false,
    dispatch_manage_all_acting_bodies_equipments: false,
    dispatch_manage_all_acting_bodies_reports: false,
    dispatch_manage_all_acting_bodies_download_report: false,
    dispatch_manage_all_acting_bodies_report_tags: false,
    dispatch_manage_finish_categories: false,
    dispatch_pause_units: false,
    dispatch_manage_equipments: false,
    dispatch_manage_all_acting_bodies_assignments: false,
    dispatch_manage_assignments: false,
    dispatch_manage_all_acting_bodies_objects_categories: false,
    dispatch_manage_all_acting_bodies_providences: false,
    dispatch_manage_all_acting_bodies_person_relations: false,
    dispatch_manage_all_acting_bodies_vehicle_relations: false,
    dispatch_manage_all_acting_bodies_unit_names: false,
    dispatch_manage_acting_body_units_unit_names: false,
    dispatch_manage_unit_displaced_reasons: false,
    dispatch_manage_all_acting_bodies_unit_displaced_reasons: false,
    dispatch_manage_all_acting_bodies_finish_categories: false,
    dispatch_manage_unit_programs: false,
    dispatch_manage_all_acting_bodies_unit_programs: false,
    dispatch_manage_police_stations: false,
    dispatch_manage_unit_pause_reasons: false,
    dispatch_manage_acting_body_units_unit_pause_reasons: false,
    dispatch_manage_all_acting_bodies_unit_pause_reasons: false,
    dispatch_manage_unit_finish_early_reasons: false,
    dispatch_manage_acting_body_units_unit_finish_early_reasons: false,
    dispatch_manage_all_acting_bodies_unit_finish_early_reasons: false,
    dispatch_manage_occurrences_bulk_finish: false,
    dispatch_manage_all_acting_bodies_occurrences_bulk_finish: false,
    dispatch_manage_patrol_indicators: false,
    dispatch_manage_all_acting_bodies_patrol_indicators: false,
    guardian_app_module_access: false,
    cloned_plate_module_access: false,
    dashboard_see_vehicles: false,
    dashboard_see_vehicles_acting_bodies: false,
    dashboard_see_vehicles_acting_body_units: false,
    supervisor_sign_report: false,
    supervisor_sign_report_unit: false,
    armory_manage_armory_shift: false,
    armory_manage_acting_body_units_armory_shift: false,
    armory_manage_all_acting_bodies_armory_shift: false,
    armory_assigned_as_armourer: false,
    armory_replace_in_charge_armourer: false,
    deac_manage_acting_body_vacancy_level: false,
    deac_manage_all_acting_bodies_vacancy_level: false,
    deac_manage_workplaces: false,
    deac_manage_acting_body_units_workplaces: false,
    deac_manage_all_acting_bodies_workplaces: false,
    deac_manage_vacancy_tags: false,
    deac_manage_vacancy_cancellation_reasons: false,
    deac_manage_vacancies: false,
    deac_visualize_vacancies: false,
    deac_manage_acting_body_units_vacancies: false,
    deac_manage_all_acting_bodies_vacancies: false,
    deac_manage_presence_control: false,
    deac_manage_acting_body_units_presence_control: false,
    deac_manage_all_acting_bodies_presence_control: false,
    deac_manage_always_fix_presence: false,
    deac_manage_acting_body_units_reports: false,
    deac_manage_all_acting_bodies_reports: false,
    deac_manage_dashboard: false,
    deac_manage_acting_body_units_dashboard: false,
    deac_manage_all_acting_bodies_dashboard: false,
    deac_manage_applications: false,
    deac_manage_acting_body_units_applications: false,
    deac_manage_all_acting_bodies_applications: false,
    deac_manage_vacancies_templates: false,
    deac_manage_acting_body_units_vacancies_templates: false,
    deac_manage_all_acting_bodies_vacancies_templates: false,
    third_party_approved_companies_manage_inscriptions: false,
    manage_third_party_donated_cameras: false,
    citizen_management: false,
    citizen_management_banishment: false,
    citizen_watch_lpr_events: false,
};

export const permissionsValuesStructure: { title: string; values: { label: string; value: string; }[]; }[][] = [
    [
        {
            title: 'facialModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'facial_module_access',
                },
                {
                    label: 'watchAllEvents',
                    value: 'facial_can_watch_all_events'
                },
                {
                    label: 'manageWantedPerson',
                    value: 'manage_wanted_person',
                },
                {
                    label: 'manageMissingPerson',
                    value: 'manage_missing_person',
                },
                {
                    label: 'liveEventsWantedPerson',
                    value: 'facial_events_wanted_person'
                },
                {
                    label: 'liveEventsMissingPerson',
                    value: 'facial_events_missing_person'
                },
                {
                    label: 'liveAlertsWantedPerson',
                    value: 'facial_alerts_wanted_person'
                },
                {
                    label: 'liveAlertsMissingPerson',
                    value: 'facial_alerts_missing_person'
                },
                {
                    label: 'manageFacialTags',
                    value: 'facial_manage_tags',
                },
            ],
        },
        {
            title: 'dispatchModule',
            values: [
                {
                    label: 'fullModuleAccessSameActingBody',
                    value: 'dispatch_module_access',
                },
                {
                    label: 'seeDispatchResume',
                    value: 'dispatch_see_resume',
                },
                {
                    label: 'manageOccurrences',
                    value: 'dispatch_manage_occurrences',
                },
                {
                    label: 'manageActingBodyOccurrences',
                    value: 'dispatch_manage_all_acting_bodies_occurrences',
                },
                {
                    label: 'reopenOccurrence',
                    value: 'reopen_occurrence',
                },
                {
                    label: 'transferOccurrence',
                    value: 'transfer_occurrence',
                },
                {
                    label: 'manageOccurrenceTags',
                    value: 'dispatch_manage_occurrence_tags',
                },
                {
                    label: 'manageActingBodyOccurrenceTags',
                    value: 'dispatch_manage_all_acting_bodies_occurrence_tags',
                },
                {
                    label: 'manageActingBodyOccurrenceTypes',
                    value: 'dispatch_manage_all_acting_bodies_occurrence_types',
                },
                {
                    label: 'manageEquipments',
                    value: 'dispatch_manage_equipments',
                },
                {
                    label: 'manageActingBodyEquipments',
                    value: 'dispatch_manage_all_acting_bodies_equipments',
                },
                {
                    label: 'generateOccurrenceReport',
                    value: 'dispatch_generate_report',
                },
                {
                    label: 'manageActingBodyReports',
                    value: 'dispatch_manage_all_acting_bodies_reports',
                },
                {
                    label: 'downloadOccurrenceReport',
                    value: 'dispatch_download_report',
                },
                {
                    label: 'downloadActingBodyOccurrenceReport',
                    value: 'dispatch_manage_all_acting_bodies_download_report',
                },
                {
                    label: 'manageReportTags',
                    value: 'dispatch_manage_report_tags',
                },
                {
                    label: 'manageActingBodyReportTags',
                    value: 'dispatch_manage_all_acting_bodies_report_tags',
                },
                {
                    label: 'manageAssignments',
                    value: 'dispatch_manage_assignments',
                },
                {
                    label: 'manageActingBodyAssignments',
                    value: 'dispatch_manage_all_acting_bodies_assignments',
                },
                {
                    label: 'manageVehicleRelations',
                    value: 'dispatch_manage_vehicle_relations',
                },
                {
                    label: 'manageActingBodyVehicleRelations',
                    value: 'dispatch_manage_all_acting_bodies_vehicle_relations',
                },
                {
                    label: 'managePersonRelations',
                    value: 'dispatch_manage_person_relations',
                },
                {
                    label: 'manageActingBodyPersonRelations',
                    value: 'dispatch_manage_all_acting_bodies_person_relations',
                },
                {
                    label: 'manageObjectsCategories',
                    value: 'dispatch_manage_objects_categories',
                },
                {
                    label: 'manageActingBodyObjectsCategories',
                    value: 'dispatch_manage_all_acting_bodies_objects_categories',
                },
                {
                    label: 'manageProvidences',
                    value: 'dispatch_manage_providences',
                },
                {
                    label: 'manageAllActingBodiesProvidences',
                    value: 'dispatch_manage_all_acting_bodies_providences',
                },
                {
                    label: 'manageTeamNames',
                    value: 'dispatch_manage_team_names',
                },
                {
                    label: 'manageActingBodyUnitsTeamNames',
                    value: 'dispatch_manage_acting_body_units_unit_names'
                },
                {
                    label: 'manageActingBodyTeamNames',
                    value: 'dispatch_manage_all_acting_bodies_unit_names',
                },
                {
                    label: 'manageUnits',
                    value: 'dispatch_manage_units',
                },
                {
                    label: 'manageActingBodyUnits',
                    value: 'dispatch_manage_acting_body_units',
                },
                {
                    label: 'manageAllActingBodiesUnits',
                    value: 'dispatch_manage_all_acting_bodies_units',
                },
                {
                    label: 'managePauseUnits',
                    value: 'dispatch_pause_units',
                },
                {
                    label: 'manageUnitDisplacedReasons',
                    value: 'dispatch_manage_unit_displaced_reasons',
                },
                {
                    label: 'manageAllActingBodiesUnitDisplacedReasons',
                    value: 'dispatch_manage_all_acting_bodies_unit_displaced_reasons',
                },
                {
                    label: 'manageFinishCategories',
                    value: 'dispatch_manage_finish_categories',
                },
                {
                    label: 'manageActingBodyFinishCategories',
                    value: 'dispatch_manage_all_acting_bodies_finish_categories',
                },
                {
                    label: 'manageUnitPrograms',
                    value: 'dispatch_manage_unit_programs',
                },
                {
                    label: 'manageActingBodyUnitPrograms',
                    value: 'dispatch_manage_all_acting_bodies_unit_programs',
                },
                {
                    label: 'managePoliceStations',
                    value: 'dispatch_manage_police_stations'
                },
                {
                    label: 'manageUnitPauseReasons',
                    value: 'dispatch_manage_unit_pause_reasons'
                },
                {
                    label: 'manageSameActingBodyUnitPauseReasons',
                    value: 'dispatch_manage_acting_body_units_unit_pause_reasons'
                },
                {
                    label: 'manageAllActingBodiesUnitPauseReasons',
                    value: 'dispatch_manage_all_acting_bodies_unit_pause_reasons'
                },
                {
                    label: 'manageUnitFinishEarlyReasons',
                    value: 'dispatch_manage_unit_finish_early_reasons'
                },
                {
                    label: 'manageSameActingBodyUnitFinishEarlyReasons',
                    value: 'dispatch_manage_acting_body_units_unit_finish_early_reasons'
                },
                {
                    label: 'manageAllActingBodiesUnitFinishEarlyReasons',
                    value: 'dispatch_manage_all_acting_bodies_unit_finish_early_reasons'
                },
                {
                    label: 'manageCityProperties',
                    value: 'dispatch_manage_city_property'
                },
                {
                    label: 'manageAllActingBodiesCityProperties',
                    value: 'dispatch_manage_all_acting_bodies_city_property'
                },
                {
                    label: 'manageHandcuffReasons',
                    value: 'dispatch_manage_handcuff_reasons'
                },
                {
                    label: 'manageAllActingBodiesHandcuffReasons',
                    value: 'dispatch_manage_all_acting_bodies_handcuff_reasons'
                },
                {
                    label: 'manageOccurrencesBulkFinish',
                    value: 'dispatch_manage_occurrences_bulk_finish'
                },
                {
                    label: 'manageAllActingBodiesOccurrencesBulkFinish',
                    value: 'dispatch_manage_all_acting_bodies_occurrences_bulk_finish'
                },
                {
                    label: 'managePatrolIndicators',
                    value: 'dispatch_manage_patrol_indicators'
                },
                {
                    label: 'manageAllActingBodiesPatrolIndicators',
                    value: 'dispatch_manage_all_acting_bodies_patrol_indicators'
                },
            ],
        },
        {
            title: 'lprModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'lpr_module_access',
                },
                {
                    label: 'watchAllEvents',
                    value: 'lpr_can_watch_all_events'
                },
                {
                    label: 'editLprDetection',
                    value: 'lpr_edit_detection',
                },
                {
                    label: 'watchLprDetectionFromMobileAgents',
                    value: 'lpr_watch_unit_detections',
                },
                {
                    label: 'lprEditDenyList',
                    value: 'lpr_edit_denylist',
                },
                {
                    label: 'lprSeeDenyList',
                    value: 'lpr_see_denylist',
                },
                {
                    label: 'lprEditIllegalDebris',
                    value: 'lpr_edit_illegal_debris',
                },
                {
                    label: 'lprSeeIllegalDebris',
                    value: 'lpr_see_illegal_debris',
                },
            ],
        },
        {
            title: 'cameraModule',
            values: [
                {
                    label: 'cameraManagement',
                    value: 'camera_management',
                },
                {
                    label: 'canWatchAllCameras',
                    value: 'camera_can_watch_all_cameras'
                },
                {
                    label: 'cameraCreateDownload',
                    value: 'camera_download_video',
                },
                {
                    label: 'cameraDownloadVideo',
                    value: 'camera_watch_download',
                },
                {
                    label: 'cameraWatchDownloadActingBodyUnits',
                    value: 'camera_watch_download_acting_body_units',
                },
                {
                    label: 'cameraWatchDownloadAllActingBodies',
                    value: 'camera_watch_download_all_acting_bodies',
                },
                {
                    label: 'cameraDownloadReport',
                    value: 'camera_download_report',
                },
                {
                    label: 'managementPointsOfInterest',
                    value: 'camera_management_point_of_interest',
                },
                {
                    label: 'manageTags',
                    value: 'camera_manage_tags',
                },
                {
                    label: 'manageDownloadTags',
                    value: 'camera_manage_download_tags',
                },
                {
                    label: 'createCameraMaintenanceRequests',
                    value: 'create_camera_maintenance_requests',
                },
                {
                    label: 'createEmergencyCameraMaintenanceRequests',
                    value: 'create_emergency_camera_maintenance_requests',
                },
                {
                    label: 'manageCameraAlertGroups',
                    value: 'manage_camera_alert_groups',
                },
                {
                    label: 'silenceCameraEvents',
                    value: 'silence_camera_events',
                },
                {
                    label: 'generateVideoAnalysis',
                    value: 'camera_video_analysis',
                },
                {
                    label: 'watchVideoAnalysis',
                    value: 'camera_watch_video_analysis',
                },
                {
                    label: 'shareMosaicWithSameUnit',
                    value: 'share_mosaic_with_same_acting_body_unit'
                },
                {
                    label: 'shareMosaicWithSameActingBody',
                    value: 'share_mosaic_with_same_acting_body'
                },
                {
                    label: 'shareMosaicWithAllActingBodies',
                    value: 'share_mosaic_with_all_acting_bodies'
                },
                {
                    label: 'generateCamerasReport',
                    value: 'camera_offline_historic_report'
                }
            ],
        },
        {
            title: 'accessModule',
            values: [
                {
                    label: 'editUserSettings',
                    value: 'access_edit_user_settings',
                },
                {
                    label: 'editUserSettingActingBody',
                    value: 'access_edit_user_acting_body_units',
                },
                {
                    label: 'editUserSettingForAllActingBodies',
                    value: 'access_edit_user_all_acting_bodies',
                },
                {
                    label: 'removeUserActingBodyUnit',
                    value: 'access_remove_user_acting_body_unit',
                },
                {
                    label: 'removeUserActingBody',
                    value: 'access_remove_user_acting_body',
                },
                {
                    label: 'removeUserForAllActingBodies',
                    value: 'access_remove_user_all_acting_bodies',
                },
                {
                    label: 'managementUserTags',
                    value: 'access_management_user_tags',
                },
                {
                    label: 'editPermissionLevelSettings',
                    value: 'access_edit_permission_level_settings',
                },
                {
                    label: 'editPermissionLevelSettingsActingBodyUnit',
                    value: 'access_edit_permission_level_settings_acting_body_unit',
                },
                {
                    label: 'editPermissionLevelSettingsAllActingBodies',
                    value: 'access_edit_permission_level_settings_all_acting_bodies',
                },
                {
                    label: 'editGroupSettings',
                    value: 'access_edit_group_settings',
                },
                {
                    label: 'editGroupSettingsActingBodyUnit',
                    value: 'access_edit_group_settings_acting_body_unit',
                },
                {
                    label: 'editGroupSettingsAllActingBodies',
                    value: 'access_edit_group_settings_all_acting_bodies',
                },
                {
                    label: 'editTurnstile',
                    value: 'access_edit_turnstile',
                },
                {
                    label: 'editPlatformSettings',
                    value: 'access_edit_platform_settings',
                },
                {
                    label: 'canManageActingBodies',
                    value: 'access_manage_acting_body',
                },
                {
                    label: 'canManageAllowedIps',
                    value: 'access_manage_allowed_ips',
                },
                {
                    label: 'canManageInstallationCompanies',
                    value: 'access_manage_installation_company',
                },
                {
                    label: 'canManageInternetCompanies',
                    value: 'access_manage_internet_company',
                },
                {
                    label: 'canManagePtzPriorities',
                    value: 'access_manage_ptz_priorities',
                },
                {
                    label: 'requiredTwoFactorAuthentication',
                    value: 'access_require_two_factor_authentication'
                },
                {
                    label: 'seeAbuseReports',
                    value: 'access_see_abuse_reports',
                },
                {
                    label: 'manageAbuseReports',
                    value: 'access_manage_abuse_reports',
                },
                {
                    label: 'manageWorkSchedules',
                    value: 'access_manage_work_schedules',
                },
                {
                    label: 'manageWorkSchedulesAllActingBodies',
                    value: 'access_manage_all_acting_bodies_work_schedules',
                },
                {
                    label: 'manageSkills',
                    value: 'access_manage_skills',
                },
                {
                    label: 'manageActingBodySkills',
                    value: 'access_manage_all_acting_bodies_skills',
                },
                {
                    label: 'manageHolidays',
                    value: 'access_manage_holidays'
                },
                {
                    label: 'manageSupportTickets',
                    value: 'manage_support_tickets'
                },
                {
                    label: 'createSupportTickets',
                    value: 'create_support_ticket'
                }
            ],
        }
    ],
    [
        {
            title: 'dashboardModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'dashboard_module_access',
                },
                {
                    label: 'dashboardSeeOccurrences',
                    value: 'dashboard_see_occurrence',
                },
                {
                    label: 'dashboardSeeCameras',
                    value: 'dashboard_see_cameras',
                },
                {
                    label: 'dashboardSeeAgents',
                    value: 'dashboard_see_agents',
                },
                {
                    label: 'dashboardSeeAgentsActingBodyUnit',
                    value: 'dashboard_see_agents_acting_body_units',
                },
                {
                    label: 'dashboardSeeAgentsActingBody',
                    value: 'dashboard_see_agents_acting_bodies',
                },
                {
                    label: 'dashboardSeeVehicles',
                    value: 'dashboard_see_vehicles',
                },
                {
                    label: 'dashboardSeeVehiclesActingBodyUnit',
                    value: 'dashboard_see_vehicles_acting_body_units',
                },
                {
                    label: 'dashboardSeeVehiclesActingBody',
                    value: 'dashboard_see_vehicles_acting_bodies',
                },
                {
                    label: 'dashboardManageMonitoringPlatesGroups',
                    value: 'dashboard_manage_monitoring_plates_groups'
                },
                {
                    label: 'dashboardManageMonitoringPlates',
                    value: 'dashboard_manage_monitoring_plates',
                },
                {
                    label: 'dashboardSeeMonitoringPlates',
                    value: 'dashboard_see_monitoring_plates'
                }
            ],
        },
        {
            title: 'smartSearchModuleAccess',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'smart_search_module_access',
                },
            ],
        },
        {
            title: 'clonedPlateModuleAccess',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'cloned_plate_module_access',
                },
            ],
        },
        {
            title: 'logsModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'logs_module_access',
                },
            ],
        },
        {
            title: 'crmModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'crm_module_access',
                },
                {
                    label: 'getCamerasPassword',
                    value: 'get_camera_password',
                },
            ],
        },
        {
            title: 'appAgentModule',
            values: [
                {
                    label: 'canSearchPeopleByPicture',
                    value: 'search_people_by_picture',
                },
                {
                    label: 'canSearchOnCortex',
                    value: 'search_people_cortex',
                },
                {
                    label: 'canSearchOnCortexAtAnyTime',
                    value: 'search_cortex_any_time',
                },
                {
                    label: 'canReceiveOccurrences',
                    value: 'receive_occurrences',
                },
                {
                    label: 'canPauseUnit',
                    value: 'app_agent_pause_unit',
                },
                {
                    label: 'canUseDeac',
                    value: 'app_agent_deac_access'
                },
                {
                    label: 'manageMobileServices',
                    value: 'app_agent_manage_services'
                }
            ],
        },
        {
            title: 'eventsModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'events_module_access',
                },
                {
                    label: 'eventsManageWantedFaceOccurrence',
                    value: 'events_manage_wanted_face_occurrence',
                },
                {
                    label: 'eventsManageMissingFaceOccurrence',
                    value: 'events_manage_missing_face_occurrence',
                },
                {
                    label: 'eventsManageNotAllowedFaceOccurrence',
                    value: 'events_manage_not_allowed__face_occurrence',
                },
                {
                    label: 'eventsManageWantedPlateOccurrence',
                    value: 'events_manage_wanted_plate_occurrence',
                },
                {
                    label: 'eventsManageWantedPlateByMobileAgentOccurrence',
                    value: 'events_manage_wanted_plate_by_mobile_agent_occurrence',
                },
                {
                    label: 'eventsManageWantedPlateByCitizenAppOccurrence',
                    value: 'events_manage_wanted_plate_by_citizen_app_occurrence',
                },
                {
                    label: 'eventsManageIrregularVehicleOccurrence',
                    value: 'events_manage_irregular_vehicle_occurrence',
                },
                {
                    label: 'eventsManageCloneSuspectOccurrence',
                    value: 'events_manage_clone_suspect_occurrence',
                },
                {
                    label: 'eventsManageIllegalDebrisOccurrence',
                    value: 'events_manage_illegal_debris_occurrence',
                },
                {
                    label: 'eventsManageAreaInvasionOccurrence',
                    value: 'events_manage_area_invasion_occurrence',
                },
                {
                    label: 'eventsManageMpWantedPlateOccurrence',
                    value: 'events_manage_mp_wanted_plate_occurrence',
                },
                {
                    label: 'eventsManageMpWantedMobileAgentPlateOccurrence',
                    value: 'events_manage_mp_wanted_mobile_agent_plate_occurrence',
                },
                {
                    label: 'eventsManageMpWantedFaceOccurrence',
                    value: 'events_manage_mp_wanted_face_occurrence',
                },
                {
                    label: 'eventsManageAlarmCenterOccurrence',
                    value: 'events_manage_alarm_center_occurrence',
                },
                {
                    label: 'eventsManageGuardianAppOccurrence',
                    value: 'events_manage_guardian_app_occurrence',
                },
                {
                    label: 'eventsManageSchoolAppOccurrence',
                    value: 'events_manage_school_app_occurrence',
                },
                {
                    label: 'eventsManageSigrcOccurrence',
                    value: 'events_manage_sigrc_occurrence',
                },
                {
                    label: 'eventsManageCortexPlateDetectedOccurrence',
                    value: 'events_manage_cortex_plate_occurrence',
                },
                {
                    label: 'eventsManageManualOccurrence',
                    value: 'events_manage_manual_occurrence',
                },
                {
                    label: 'eventsManageCameraDepredationOccurrence',
                    value: 'events_manage_camera_depredation_occurrence',
                },
            ],
        },
        {
            title: 'guardianAppModule',
            values: [
                {
                    label: 'fullModuleAccess',
                    value: 'guardian_app_module_access',
                },
            ],
        },
        {
            title: 'signaturesModule',
            values: [
                {
                    label: 'supervisorSignReport',
                    value: 'supervisor_sign_report'
                },
                {
                    label: 'supervisorSignReportUnit',
                    value: 'supervisor_sign_report_unit'
                }
            ]
        },
        {
            title: 'armoryModule',
            values: [
                {
                    label: 'armoryShiftManagementSameUnit',
                    value: 'armory_manage_armory_shift'
                },
                {
                    label: 'armoryShiftManagementSameActingBody',
                    value: 'armory_manage_acting_body_units_armory_shift'
                },
                {
                    label: 'armoryShiftManagementAllActingBody',
                    value: 'armory_manage_all_acting_bodies_armory_shift'
                },
                {
                    label: 'canBeAssignedAsArmourer',
                    value: 'armory_assigned_as_armourer'
                },
                {
                    label: 'canReplaceInChargeArmourer',
                    value: 'armory_replace_in_charge_armourer'
                }
            ]
        },
        {
            title: 'deacModule',
            values: [
                {
                    label: 'vacancyLevelsManagementSameActingBody',
                    value: 'deac_manage_acting_body_vacancy_level'
                },
                {
                    label: 'vacancyLevelsManagementAllActingBody',
                    value: 'deac_manage_all_acting_bodies_vacancy_level'
                },
                {
                    label: 'workplacesManagementSameUnit',
                    value: 'deac_manage_workplaces'
                },
                {
                    label: 'workplacesManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_workplaces'
                },
                {
                    label: 'workplacesManagementAllActingBody',
                    value: 'deac_manage_all_acting_bodies_workplaces'
                },
                {
                    label: 'vacancyTagsManagement',
                    value: 'deac_manage_vacancy_tags'
                },
                {
                    label: 'vacancyCancellationReasonsManagement',
                    value: 'deac_manage_vacancy_cancellation_reasons'
                },
                {
                    label: 'vacanciesManagementSameUnit',
                    value: 'deac_manage_vacancies',
                },
                {
                    label: 'vacanciesVisualizeSameUnit',
                    value: 'deac_visualize_vacancies',
                },
                {
                    label: 'vacanciesManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_vacancies',
                },
                {
                    label: 'vacanciesManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_vacancies',
                },
                {
                    label: 'presenceControlManagementSameUnit',
                    value: 'deac_manage_presence_control',
                },
                {
                    label: 'presenceControlManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_presence_control',
                },
                {
                    label: 'presenceControlManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_presence_control',
                },
                {
                    label: 'presenceControlAlwaysFixPresence',
                    value: 'deac_manage_always_fix_presence'
                },
                {
                    label: 'reportsManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_reports'
                },
                {
                    label: 'reportsManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_reports'
                },
                {
                    label: 'dashboardManagementSameUnit',
                    value: 'deac_manage_dashboard',
                },
                {
                    label: 'dashboardManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_dashboard',
                },
                {
                    label: 'dashboardManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_dashboard',
                },
                {
                    label: 'applicationsManagementSameUnit',
                    value: 'deac_manage_applications',
                },
                {
                    label: 'applicationsManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_applications',
                },
                {
                    label: 'applicationsManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_applications',
                },
                {
                    label: 'vacanciesTemplatesManagementSameUnit',
                    value: 'deac_manage_vacancies_templates',
                },
                {
                    label: 'vacanciesTemplatesManagementSameActingBody',
                    value: 'deac_manage_acting_body_units_vacancies_templates',
                },
                {
                    label: 'vacanciesTemplatesManagementAllActingBodies',
                    value: 'deac_manage_all_acting_bodies_vacancies_templates',
                },
            ]
        },
        {
            title: 'thirdPartyApprovedCompaniesModule',
            values: [
                {
                    label: 'thirdPartyApprovedCompaniesInscriptionsManagement',
                    value: 'third_party_approved_companies_manage_inscriptions'
                },
                {
                    label: 'manageDonatedCameras',
                    value: 'manage_third_party_donated_cameras'
                },
            ]
        },
        {
            title: 'citizenModule',
            values: [
                {
                    label: 'citizenManagement',
                    value: 'citizen_management'
                },
                {
                    label: 'citizenManagementBanishment',
                    value: 'citizen_management_banishment'
                },
                {
                    label: 'citizenWatchLprEvents',
                    value: 'citizen_watch_lpr_events'
                }
            ]
        }
    ],
];

export default function PermissionLevelForm() {
    const navigation = useNavigation<NavigationProp<AccessParamList>>();
    const route = useRoute<RouteProp<AccessParamList, 'PermissionLevelForm'>>();
    const permissionLevelId = route.params?.id;
    const { styles, theme } = useStyles(styleSheet);
    const { user: authenticatedUser } = useAuth();
    const [actingBodyId, setActingBodyId] = useState<number>(0);
    const [actingBodyUnitId, setActingBodyUnitId] = useState<number>(0);
    const windowInfo = WindowInformation();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [sessionValidityTime, setSessionValidityTime] = useState(0);
    const [sessionQuantityLimit, setSessionQuantityLimit] = useState(0);
    const [mobileSessionValidityTime, setMobileSessionValidityTime] = useState(0);
    const [mobileSessionQuantityLimit, setMobileSessionQuantityLimit] = useState(0);

    const [selectableUsers, setSelectableUsers] = useState<SelectableItem[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<SelectableItem[]>([]);
    const [permissionLevelUserIds, setPermissionLevelUserIds] = useState<number[]>([]);
    const [permissions, setPermissions] = useState<UserPermissions>(defaultPermissionsValue);

    function cleanValues() {
        setName('');
        setDescription('');
        setSelectedUsers([]);
        setSelectableUsers([]);
        setActingBodyId(0);
        setActingBodyUnitId(0);
        setPermissions(defaultPermissionsValue);
        setSessionValidityTime(0);
        setSessionQuantityLimit(0);
        setMobileSessionValidityTime(0);
        setMobileSessionQuantityLimit(0);
    }

    async function getPermissionLevel(id: number) {
        const permissionLevel = await accessService.getPermissionLevel(id);
        setName(permissionLevel.name);
        setDescription(permissionLevel.description);
        setSessionValidityTime(permissionLevel.sessionValidityTime ? permissionLevel.sessionValidityTime / 60 : 0);
        setSessionQuantityLimit(permissionLevel.sessionQuantityLimit ? permissionLevel.sessionQuantityLimit : 0);
        setMobileSessionValidityTime(permissionLevel.mobileSessionValidityTime ? permissionLevel.mobileSessionValidityTime / 60 : 0);
        setMobileSessionQuantityLimit(permissionLevel.mobileSessionQuantityLimit ? permissionLevel.mobileSessionQuantityLimit : 0);
        setPermissions(permissionLevel.permissionObj);

        if (permissionLevel.actingBodyUnit?.actingBodyId) {
            setActingBodyId(permissionLevel.actingBodyUnit.actingBodyId);
            setActingBodyUnitId(permissionLevel.actingBodyUnitId);

            const users = await loadUsers(permissionLevel.actingBodyUnit.id || 0);
            const selectedUsers = permissionLevel.Users.map((user) => {
                return {
                    id: user.id || 0,
                    name: user.name
                };
            });
            setSelectedUsers(selectedUsers);

            setSelectableUsers((users || [])
                .filter((user) => !selectedUsers.find((permissionLevelUser) => permissionLevelUser.id == user.id))
                .map((user) => {
                    return {
                        id: user.id || 0,
                        name: user.name
                    };
                })
            );
            setPermissionLevelUserIds(permissionLevel.Users.map((user) => user.id || 0));

        }
    }

    async function loadPageInfo(authenticatedUser: AuthenticatedUser) {
        try {
            if (permissionLevelId) {
                await getPermissionLevel(permissionLevelId);
            } else {
                setPermissions(defaultPermissionsValue);
                if (!(authenticatedUser.isAdmin
                    || authenticatedUser.permissions.access_edit_permission_level_settings_all_acting_bodies) && authenticatedUser.actingBodyUnitId) {
                    setActingBodyId(authenticatedUser.role?.actingBody?.id || 0);
                    if (!authenticatedUser.permissions.access_edit_permission_level_settings_acting_body_unit) {
                        setActingBodyUnitId(authenticatedUser.actingBodyUnitId);
                    }
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    async function loadUsers(actingBodyUnitId: number) {
        try {
            const users = await accessService.getAccessAllUsers({ actingBodyUnitId: actingBodyUnitId });
            return users;
        } catch (err) {
            console.error(err);
        }
    }

    const isFocused = useIsFocused();
    useFocusEffect(useCallback(() => {
        if (isFocused && authenticatedUser) {
            loadPageInfo(authenticatedUser);
        }
    }, [isFocused, navigation, route.params, authenticatedUser]));

    function isEmpty(value: string) {
        return value == '';
    }

    function isFormValid() {
        if ((authenticatedUser?.isAdmin
            || authenticatedUser?.permissions.access_edit_permission_level_settings_all_acting_bodies
            || authenticatedUser?.permissions.access_edit_permission_level_settings_acting_body_unit) && actingBodyUnitId === 0) {
            return false;
        }
        return !isEmpty(name);
    }

    async function changedUnit(unitId: number) {
        const users = await loadUsers(unitId);

        setSelectableUsers((users || []).map((user) => {
            return {
                id: user.id || 0,
                name: user.name
            };
        }));
    }

    useEffect(() => {
        if (actingBodyId !== 0) {
            setSelectedUsers([]);
            setSelectableUsers([]);
        }

        if (actingBodyUnitId !== 0 && !permissionLevelId) {
            changedUnit(actingBodyUnitId);
        }
    }, [actingBodyId, actingBodyUnitId]);

    async function formSubmit() {
        try {
            if (permissionLevelId) {
                const selectedUserIds = selectedUsers.map((user) => Number(user.id));
                const usersToAdd = selectedUserIds.filter((selectedUserId) => !permissionLevelUserIds.includes(selectedUserId));
                const usersToRm = permissionLevelUserIds.filter((permissionLevelUserId) => !selectedUserIds.includes(permissionLevelUserId));

                await accessService.updatePermissionLevel(permissionLevelId, {
                    name,
                    description,
                    usersToAdd,
                    usersToRm,
                    permissions,
                    sessionValidityTime: sessionValidityTime * 60,
                    sessionQuantityLimit: sessionQuantityLimit,
                    mobileSessionValidityTime: mobileSessionValidityTime * 60,
                    mobileSessionQuantityLimit: mobileSessionQuantityLimit
                });
            } else {
                await accessService.createPermissionLevel({
                    name,
                    description,
                    usersToAdd: selectedUsers.map(item => Number(item.id)),
                    permissions,
                    actingBodyUnitId: actingBodyUnitId,
                    sessionValidityTime: sessionValidityTime * 60,
                    sessionQuantityLimit: sessionQuantityLimit,
                    mobileSessionValidityTime: mobileSessionValidityTime * 60,
                    mobileSessionQuantityLimit: mobileSessionQuantityLimit
                });
            }

            cleanValues();
            navigation.navigate('PermissionLevels', {
                page: 1,
                limit: 25,
            });

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    if (!authenticatedUser) {
        return <></>;
    }

    return (
        <Container>
            <Header
                title={translate('registerPermissionLevel')}
                goBackAction={() => {
                    cleanValues();
                    navigation.canGoBack() ? navigation.goBack() : navigation.navigate('PermissionLevels', {
                        page: 1,
                        limit: 25,
                    });
                }}
                actions={<CustomButton
                    text={translate('save')}
                    disabled={!isFormValid()}
                    onPress={formSubmit}
                />}
            />
            <Card>

                <Tabs tabs={[{
                    key: 'details',
                    label: translate('details')
                }, {
                    key: 'users',
                    label: translate('users')
                }, {
                    key: 'permissions',
                    label: translate('permissions')
                }]}>
                    {({ selectedTab }) => {
                        if (selectedTab == 'details') {
                            return (<ScrollView contentContainerStyle={styles.detailsContainer}>
                                {(authenticatedUser.isAdmin || authenticatedUser.permissions.access_edit_permission_level_settings_all_acting_bodies) &&
                                    <ActingBodiesDropdown
                                        value={actingBodyId}
                                        setValue={setActingBodyId}
                                        zIndex={3}
                                        disabled={!!permissionLevelId}
                                        includeAllOption={false}
                                        required={true}
                                    />
                                }
                                {(authenticatedUser.isAdmin
                                    || authenticatedUser.permissions.access_edit_permission_level_settings_all_acting_bodies
                                    || authenticatedUser.permissions.access_edit_permission_level_settings_acting_body_unit) &&
                                    <ActingBodiesUnitsDropdown
                                        actingBodyId={actingBodyId}
                                        value={actingBodyUnitId}
                                        setValue={setActingBodyUnitId}
                                        zIndex={2}
                                        disabled={!!permissionLevelId}
                                        required={true}
                                    />
                                }
                                <FormInput
                                    label={translate('name')}
                                    placeholder={translate('name')}
                                    value={name}
                                    onChangeText={setName}
                                    invalid={isEmpty}
                                    required={true}
                                />
                                <FormInput
                                    label={translate('description')}
                                    placeholder={translate('description')}
                                    value={description}
                                    onChangeText={setDescription}
                                    invalid={() => false}
                                />
                                <Divider />
                                <View style={{ flexDirection: 'column', gap: 16 }}>
                                    <MyAppText style={{ fontSize: 18, fontWeight: '700', color: theme.colors.primary['500'] }}>{translate('configuration')}</MyAppText>
                                    <View style={{ flex: 1, gap: 10 }}>
                                        <View style={{ flexDirection: windowInfo.isMobile ? 'column' : 'row' }}>
                                            <View style={{ flex: 1, gap: 16 }}>
                                                <MyAppText style={{ fontSize: 16, fontWeight: '600', color: theme.colors.primary['500'] }}>{translate('desktop')}</MyAppText>
                                                <View style={{ gap: 8 }}>
                                                    <MyAppText style={{ color: theme.colors.labelColor, fontSize: 14, fontWeight: 'bold' }}>
                                                        {translate('sessionDuration')}
                                                    </MyAppText>
                                                    <View style={[{ flexDirection: 'row' }]}>
                                                        <TextInputMask
                                                            value={String(sessionValidityTime)}
                                                            includeRawValueInChangeText={true}
                                                            onChangeText={(maskedText, rawText) => {
                                                                setSessionValidityTime(Number(rawText));
                                                            }}
                                                            type={'only-numbers'}
                                                            style={[styles.inputAttached, { maxWidth: 70, textAlign: 'center' }]}
                                                        />
                                                        <MyAppText style={styles.inputAttach}>{translate('minutes')}</MyAppText>
                                                    </View>
                                                    <MyAppText style={{ color: theme.colors.card.detailText, fontSize: 14 }}>{
                                                        translate('sessionDurationExplanation')}
                                                    </MyAppText>
                                                </View>
                                                <View style={{ gap: 8 }}>
                                                    <MyAppText style={{ color: theme.colors.labelColor, fontSize: 14, fontWeight: 'bold' }}>
                                                        {translate('sessionLimit')}
                                                    </MyAppText>
                                                    <View style={[{ flexDirection: 'row' }]}>
                                                        <TextInputMask
                                                            value={String(sessionQuantityLimit)}
                                                            includeRawValueInChangeText={true}
                                                            onChangeText={(maskedText, rawText) => {
                                                                setSessionQuantityLimit(Number(rawText));
                                                            }}
                                                            type={'only-numbers'}
                                                            style={[styles.input, { maxWidth: 70, textAlign: 'center' }]}
                                                        />
                                                    </View>
                                                    <MyAppText style={{ color: theme.colors.card.detailText, fontSize: 14 }}>{
                                                        translate('sessionLimitExplanation')}
                                                    </MyAppText>
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, gap: 16 }}>
                                                <MyAppText style={{ fontSize: 16, fontWeight: '600', color: theme.colors.primary['500'] }}>{translate('mobile')}</MyAppText>
                                                <View style={{ gap: 8 }}>
                                                    <MyAppText style={{ color: theme.colors.labelColor, fontSize: 14, fontWeight: 'bold' }}>
                                                        {translate('sessionDuration')}
                                                    </MyAppText>
                                                    <View style={[{ flexDirection: 'row' }]}>
                                                        <TextInputMask
                                                            value={String(mobileSessionValidityTime)}
                                                            includeRawValueInChangeText={true}
                                                            onChangeText={(maskedText, rawText) => {
                                                                setMobileSessionValidityTime(Number(rawText));
                                                            }}
                                                            type={'only-numbers'}
                                                            style={[styles.inputAttached, { maxWidth: 70, textAlign: 'center' }]}
                                                        />
                                                        <MyAppText style={styles.inputAttach}>{translate('minutes')}</MyAppText>
                                                    </View>
                                                    <MyAppText style={{ color: theme.colors.card.detailText, fontSize: 14 }}>{
                                                        translate('sessionDurationExplanation')}
                                                    </MyAppText>
                                                </View>
                                                <View style={{ gap: 8 }}>
                                                    <MyAppText style={{ color: theme.colors.labelColor, fontSize: 14, fontWeight: 'bold' }}>
                                                        {translate('sessionLimit')}
                                                    </MyAppText>
                                                    <View style={[{ flexDirection: 'row' }]}>
                                                        <TextInputMask
                                                            value={String(mobileSessionQuantityLimit)}
                                                            includeRawValueInChangeText={true}
                                                            onChangeText={(maskedText, rawText) => {
                                                                setMobileSessionQuantityLimit(Number(rawText));
                                                            }}
                                                            type={'only-numbers'}
                                                            style={[styles.input, { maxWidth: 70, textAlign: 'center' }]}
                                                        />
                                                    </View>
                                                    <MyAppText style={{ color: theme.colors.card.detailText, fontSize: 14 }}>{
                                                        translate('sessionLimitExplanation')}
                                                    </MyAppText>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </ScrollView>);
                        } else if (selectedTab == 'users') {
                            return <SelectableList
                                selectableLabel={translate('users')}
                                selectableContent={selectableUsers}
                                selectedLabel={translate('participants')}
                                selectedContent={selectedUsers}
                            />;
                        } else if (selectedTab == 'permissions') {
                            return (
                                <ScrollView contentContainerStyle={styles.permissionsContainer}>
                                    {permissionsValuesStructure.map((permissionsArray, index) => (
                                        <View key={index} style={styles.permissionMainColumn}>
                                            {permissionsArray.map((permission, permissionsIndex) => (
                                                <View key={permissionsIndex} style={styles.permissionColumn}>
                                                    <MyAppText style={styles.permissionSubTitle}>{translate(permission.title)}</MyAppText>
                                                    {permission.values.map(permissionValue => (
                                                        <MyCheckbox
                                                            key={permissionValue.value}
                                                            label={translate(permissionValue.label)}
                                                            checked={permissions[permissionValue.value as keyof UserPermissions]}
                                                            setChecked={(value) => {
                                                                setPermissions(() => ({
                                                                    ...permissions,
                                                                    [permissionValue.value as keyof UserPermissions]: value
                                                                }));
                                                            }}
                                                        />
                                                    ))}
                                                </View>
                                            ))}
                                        </View>
                                    ))}
                                </ScrollView>
                            );
                        }
                    }}
                </Tabs>
            </Card>
        </Container>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    detailsContainer: {
        flex: 1,
        flexDirection: 'column',
        gap: 16,
    },
    permissionsContainer: {
        rowGap: 20,
        flexDirection: 'row',
        flex: 1,
        flexWrap: 'wrap'
    },
    permissionMainColumn: {
        flex: 1,
        flexDirection: 'column',
        gap: 15,
        minWidth: 200
    },
    permissionColumn: {
        flexDirection: 'column',
        gap: 8,
    },
    permissionSubTitle: {
        color: theme.colors.labelColor,
        fontWeight: 'bold',
        fontSize: 14,
    },
    input: {
        fontSize: 16,
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.container.background,
        maxHeight: 40,
        padding: 10,
        color: theme.colors.textColor,
        borderWidth: 1,
        borderColor: theme.colors.container.border,
        borderRadius: 4
    },
    inputAttached: {
        fontSize: 16,
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.container.background,
        maxHeight: 40,
        padding: 10,
        color: theme.colors.textColor,
        borderWidth: 1,
        borderColor: theme.colors.container.border,
        borderTopStartRadius: 4,
        borderBottomStartRadius: 4,
    },
    inputAttach: {
        color: theme.colors.textColor,
        fontSize: 13,
        backgroundColor: theme.colors.container.border,
        maxHeight: 40,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: theme.colors.container.border,
        borderTopEndRadius: 4,
        borderBottomEndRadius: 4,
        padding: 11,
    },
}));
